import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { NotificationsName } from '../name';
import { patchNotifications } from '../../api';
import { updateNotifications } from '../@sync/update';

export const notificationsPatchSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		preRequestActionCreators: [ updateNotifications.syncActionCreator ]
	},
	name: NotificationsName,
	receive: false,
	request: false,
	requestHandler: patchNotifications
});
